export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20lifestyle%20workspace%20with%20open%20laptop%20showing%20product%20catalog%20grid%2C%20fashion%20sneakers%20and%20folded%20hoodie%20artistically%20placed%20nearby%2C%20warm%20natural%20sunlight%20from%20large%20window%2C%20cream%20textured%20walls%2C%20soft%20shadows%2C%20editorial%20productivity%20photography%20with%20neutral%20warm%20tones&width=1920&height=1080&seq=hero-sugargoo-main-2026&orientation=landscape&nocache=true"
          alt="Sugargoo Spreadsheet workspace with lifestyle products"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-background-200/50 mb-6">
          <i className="ri-sparkling-line text-primary-500 text-sm"></i>
          <span className="text-xs font-label font-medium text-foreground-700">Updated Weekly Database</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5">
          Sugargoo Spreadsheet
        </h1>
        <p className="text-lg md:text-xl text-white/90 font-body font-light max-w-2xl mx-auto leading-relaxed mb-8">
          The Ultimate Product Database &amp; Shopping Guide. Discover thousands of organized Sugargoo Spreadsheet finds, product guides, shipping tips, warehouse information, reviews and exclusive shopping resources.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-sm md:text-base font-label font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-[0_8px_30px_rgba(0,0,0,0.12)]"
          >
            sugargoo spreadsheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto flex items-center justify-center gap-2 px-8 py-3.5 rounded-full bg-white/95 text-foreground-900 text-sm md:text-base font-label font-semibold hover:bg-white transition-all cursor-pointer whitespace-nowrap"
          >
            buy it now
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 text-white/80 text-xs md:text-sm font-label">
          <div className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            <span>Updated Database</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            <span>Beginner Friendly</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            <span>Independent Resource</span>
          </div>
          <div className="flex items-center gap-1.5">
            <i className="ri-checkbox-circle-line text-accent-400"></i>
            <span>Shopping Guides</span>
          </div>
        </div>
      </div>
    </section>
  );
}